import { render, staticRenderFns } from "./FooterStaff.vue?vue&type=template&id=1f5134f1&"
import script from "./FooterStaff.vue?vue&type=script&lang=js&"
export * from "./FooterStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports